import { render, staticRenderFns } from "./PsikologisHasilJawaban.vue?vue&type=template&id=a453c758"
import script from "./PsikologisHasilJawaban.vue?vue&type=script&lang=js"
export * from "./PsikologisHasilJawaban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports